import beauthBrowser from '@/lib/beauth/beauth.browser';

export const tokenManager = {
    get: (): string | null => beauthBrowser.token(),

    subscribe: (listener: (token: string | null) => void): (() => void) => {
        let last = beauthBrowser.token();
        return beauthBrowser.subscribe((state) => {
            if (state.access === last) return;
            last = state.access;
            listener(state.access);
        });
    },
};

export default tokenManager;
